import { useEffect } from 'react'

import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { saleTypesFilter, saleTypesFilterSelection } from 'app/dataProviders/filter-items'

export const SaleTypesFilter = () => {
  useEffect(() => {
    saleTypesFilter.dataReceive()
    return () => {
      saleTypesFilter.resetToDefault()
      saleTypesFilterSelection.resetToDefault()
    }
  }, [])

  return (
    <PlainItemsSelectorBox
      id="saleType"
      label="Тип продукции"
      header="Выбор типа продукции"
      pleaseSelectText="Выберите тип продукции"
      dataBoxData={saleTypesFilter}
      dataBoxSelection={saleTypesFilterSelection}
      multiple
      colorInverse
      wide
    />
  )
}
